import { createTranslationRef, createTranslationResource } from '@backstage/core-plugin-api/alpha';

export const componentTranslationRef = createTranslationRef({
  id: 'component',
  messages: {
    componentForm: {
      title: 'Component Information',
    },
    componentTableColumns: {
      name: 'Name',
      title: 'Title',
      type: 'Type',
      application: 'Application',
      project: 'Project',
      lifecycle: 'Lifecycle',
    },
  },
});

export const componentTranslations = createTranslationResource({
  ref: componentTranslationRef,
  translations: {
    en: () => import('./component-en'),
    es: () => import('./component-es'),
  },
});